module.exports = __webpack_public_path__ + "img/border2.a018f926.png";